export const CF_URL = "https://us-central1-checkpro-3a90a.cloudfunctions.net";
